import {selectedBuilding,withBuildingScope} from './building-scope';

const localOrigin='https://staff.invalid';
const uuid='[a-f0-9-]{36}';
const detailRoutes:Array<[RegExp,string]>=[
 [new RegExp(`^/records/(?:person|organisation)/${uuid}$`,'i'),'Contact'],
 [new RegExp(`^/(?:records/premises/${uuid}|buildings/[^/]+/properties/${uuid})$`,'i'),'Property'],
 [new RegExp(`^/work/cases/${uuid}(?:/maintenance)?$`,'i'),'Work record'],
 [new RegExp(`^/work/suppliers/${uuid}/setup$`,'i'),'Supplier'],
 [new RegExp(`^/documents/${uuid}$`,'i'),'Document'],
 [new RegExp(`^/communications/threads/${uuid}$`,'i'),'Conversation'],
 [new RegExp(`^/compliance/obligations/${uuid}$`,'i'),'Compliance record'],
];

/** A label for existing record routes, not another record or navigation registry. */
export function workflowRecordLabel(pathname:string,search=''):string|undefined {
 if(new RegExp(`^/buildings/${uuid}/governance/decisions$`,'i').test(pathname)&&new RegExp(`^${uuid}$`,'i').test(new URLSearchParams(search).get('decision')??''))return 'Governance decision';
 if(pathname==='/finance/payables'&&new RegExp(`^${uuid}$`,'i').test(new URLSearchParams(search).get('invoice')??''))return 'Invoice';
 return detailRoutes.find(([pattern])=>pattern.test(pathname))?.[1];
}

export function safeWorkflowReturn(value:string|null|undefined){
 if(!value||!/^\/(?:reports(?:\?|$)|operations\/resources(?:\?|$)|my-work(?:\?|$)|work(?:\?|$)|search(?:\?|$)|work\/reviews(?:\?|$)|records\/(?:person|organisation|premises)\/[a-f0-9-]{36}(?:\?|$)|buildings\/[a-z0-9-]+\/(?:onboarding|genie|setup|governance\/decisions|mobilisation\/premises|properties\/[a-f0-9-]{36})(?:\?|$)|work\/cases\/[a-f0-9-]+(?:\/maintenance)?(?:\?|$)|work\/suppliers\/[a-f0-9-]+\/setup(?:\?|$)|communications\/threads\/[a-f0-9-]{36}(?:\?|$)|(?:finance\/(?:payables|documents|service-charges)|compliance\/(?:documents|obligations\/[a-f0-9-]+)|work\/documents|documents(?:\/(?:[a-f0-9-]{36}|review|ownership|media(?:\/review)?))?)(?:\?|$))/i.test(value)
  ||value.includes('\\'))return undefined;
 const url=new URL(value,localOrigin);
 url.searchParams.delete('returnTo');
 return url.pathname+url.search;
}

export function withWorkflowReturn(href:string,returnTo:string){
 if(!href.startsWith('/')||href.startsWith('//')||href.includes('\\'))return href;
 const safe=safeWorkflowReturn(returnTo),url=new URL(href,localOrigin);
 if(safe){
  const destination=new URL(safe,localOrigin),comparison=new URL(url);
  const targetBuilding=selectedBuilding(url.pathname,url.search),originBuilding=selectedBuilding(destination.pathname,destination.search);
  comparison.searchParams.delete('returnTo');comparison.searchParams.sort();destination.searchParams.sort();
  if(targetBuilding&&originBuilding&&targetBuilding!==originBuilding||comparison.pathname+comparison.search===destination.pathname+destination.search)url.searchParams.delete('returnTo');
  else url.searchParams.set('returnTo',safe);
 }
 return url.pathname+url.search+url.hash;
}

/** Carry the original task through related records; explicit building changes leave it. */
export function contextualRecordHref(href:string,pathname:string,search:string){
 const scoped=withBuildingScope(href,selectedBuilding(pathname,search));
 if(!scoped.startsWith('/')||scoped.startsWith('//'))return scoped;
 const target=new URL(scoped,localOrigin),sourceBuilding=selectedBuilding(pathname,search),targetBuilding=selectedBuilding(target.pathname,target.search);
 if(target.pathname.startsWith('/portal')||target.pathname.startsWith('/procurement/respond'))return scoped;
 if(sourceBuilding&&targetBuilding&&sourceBuilding!==targetBuilding){target.searchParams.delete('returnTo');return target.pathname+target.search+target.hash;}
 if(target.searchParams.has('returnTo'))return scoped;
 const inherited=safeWorkflowReturn(new URLSearchParams(search).get('returnTo'));
 const origin=inherited??(workflowRecordLabel(pathname,search)&&workflowRecordLabel(target.pathname,target.search)?safeWorkflowReturn(pathname+search):undefined);
 return origin?withWorkflowReturn(scoped,origin):scoped;
}
